__turbopack_context__.v({
  "articlesGrid": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__articlesGrid",
  "contentArea": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__contentArea",
  "divider": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__divider",
  "eventsWrapper": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__eventsWrapper",
  "tabRow": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__tabRow",
  "wrapper": "ArticlesAndEventsTabs-module-scss-module__jPLxQq__wrapper",
});
